import { useEffect } from 'react';
import { request } from './spoylApi';

/**
 * Tells the server the player's app is open, so the owner's Clients page can
 * show real time-on-app.
 *
 * Only beats while the tab is **visible**: a game left open in a background tab
 * is not time the player is spending, and counting it would turn "engaged for
 * two hours" into a lie. The server treats the gap that opens when the tab is
 * hidden as the end of a session, so nothing has to be sent on the way out.
 *
 * Fire-and-forget: a dropped beat costs a few seconds of one player's total and
 * nothing else, so a failure is swallowed rather than surfaced.
 */
const HEARTBEAT_INTERVAL_MS = 45_000;

export function useHeartbeat(): void {
  useEffect(() => {
    const beat = () => {
      if (document.visibilityState !== 'visible') return;
      void request('/heartbeat', { method: 'POST' }).catch(() => {
        // Best-effort; the next beat tries again.
      });
    };

    beat(); // Count the open itself, not only the first interval later.
    const timer = window.setInterval(beat, HEARTBEAT_INTERVAL_MS);
    // Coming back to the tab should resume counting at once, and also lets the
    // server close the away-gap as a finished session.
    document.addEventListener('visibilitychange', beat);

    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', beat);
    };
  }, []);
}
